<div class="highlight" *ngIf="config">
  <giq-complex-donut-chart
    class="chart"
    [metadata]="info"
  ></giq-complex-donut-chart>
</div>
